import * as React from 'react';

function Benefits() {
    return(
        <React.Fragment>
           
            <div className="beneficios"><span className="beneficios-emoji">&#10024;</span>
                                            &nbsp;Beneficios&nbsp;
                                        <span className="beneficios-emoji">&#10024;</span></div>

            
            <div className="couple">
                <div className="benefit">
                    <div id="icono"><span className="benefitData logo material-icons-round icono">access_time_filled</span></div>
                    <div id='benefitText' className="benefitData text">
                    <span className='highlight'>¡Optimiza tu tiempo!&nbsp;</span>&#9201; Aprovecha lo realmente escaso y deja que la tecnología trabaje para ti &#128126;
                    </div>
                </div>

                <div className="benefit">
                    <div id="icono"><span className="benefitData logo material-icons-round icono">device_hub</span></div>
                    <div id='benefitText' className="benefitData text">
                        <span className='highlight'>¡Bienvenido al futuro!</span>&#128302; La tecnología ha cambiado la forma en la que hacemos todo &#127939; no te quedes atrás 
                    </div>
                </div>
            </div>
            

            <div className="couple">
                <div className="benefit">
                <div id="icono"><span className="benefitData logo material-icons-round icono">savings</span></div>
                    <div id='benefitText' className="benefitData text">
                            <span className='highlight'>¡Ahorra!&nbsp;</span>&#x1f4b8; Deja las tareas simples y repetitivas a quienes lo hacen mejor: los computadores &#128176;
                    </div>
                </div>

                <div className="benefit">
                    <div id="icono"><span className="benefitData logo material-icons-round icono">precision_manufacturing</span></div>
                    <div id='benefitText' className="benefitData text">
                        Subete a la cuarta <span className='highlight'>revolución</span> industrial  &#129302; con la <span className='highlight'>automatizaciòn</span> de procesos en tu firma &#128377; 
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

export { Benefits }